angular.module('mtic').service('apiErrorInterpeter', function (ERROR_CODES, $log, language) {
      return {
            get: function (group, message, type) {
                  if(message === 'FAILED_TO_CONNECT'){
                        return language.get('11324')
                  }else
                  if (ERROR_CODES[group][message]) {
                        return language.get(ERROR_CODES[group][message])
                  } else {
                        return language.get(ERROR_CODES.UNKNOWN)
                        $log.error('An UNKNOWN error was returned from the api', group, message)
                  }
            }
      }
});
